import { EyeOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { ColumnsType } from 'antd/es/table'
import PreviewShipmentBlank from '../../../../components/buttons/preview-shipment-blank/preview-shipment-blank'
import formatMachineBrands from '../../../../helpers/calculations/formatters/format-machine-brands'
import PrintQueueEntry from '../../../../types/api/print-queue-entry'
import PreparedCheckbox from './components/prepared-checkbox'

export const columns: ColumnsType<PrintQueueEntry> = [
    { dataIndex: 'id', title: 'ID' },
    { dataIndex: 'sort', title: 'Порядок', width: 70 },
    { title: 'Номер отгрузки', render: (_, r) => r.print_job?.shipment?.id || '-', width: 110 },
    { title: 'Заказчик', render: (_, r) => r.print_job?.shipment?.client?.name || '-' },
    {
        title: 'Тираж',
        render: (_, r) =>
            r.print_job?.shipment?.shipment_positions?.reduce(
                (acc, pos) => acc + (pos.copies || 0),
                0
            ) || '-',
    },
    {
        title: 'Штамп / тубус',
        render: (_, r) =>
            `${r.print_job?.shipment?.stamp?.number || '-'} / ${
                r.print_job?.shipment?.stamp?.tube?.id || 'нет'
            }`,
    },
    {
        title: 'Формы (комплект)',
        render: (_, r) => r.print_job?.shipment?.numberOfForms || '-',
        width: 130,
    },
    {
        title: 'Станок',
        render: (_, r) =>
            formatMachineBrands({ machine: r.print_job?.shipment?.machine }) ||
            r.machine?.name ||
            '-',
    },
    {
        title: 'Бланк',
        render: (_, r) => {
            const s = r.print_job?.shipment
            return s ? (
                <PreviewShipmentBlank
                    shipment={{ documentId: s.documentId }}
                    blankType='production'
                    blankPreviewFiles={s.blankPreviewFiles}
                >
                    <Button
                        title='Посмотреть бланк'
                        size='small'
                        icon={<EyeOutlined />}
                        color='magenta'
                        variant='solid'
                    />
                </PreviewShipmentBlank>
            ) : (
                '-'
            )
        },
    },
    {
        dataIndex: 'stampPrepared',
        title: 'Штамп',
        render: (_, record) => (
            <PreparedCheckbox
                key={record.documentId + '_stamp'}
                record={record}
                field='stampPrepared'
            />
        ),
    },
    {
        dataIndex: 'formsPrepared',
        title: 'Формы',
        render: (_, record) => (
            <PreparedCheckbox
                key={record.documentId + '_forms'}
                record={record}
                field='formsPrepared'
            />
        ),
    },
    {
        dataIndex: 'blankPrepared',
        title: 'Бланк',
        render: (_, record) => (
            <PreparedCheckbox
                key={record.documentId + '_blank'}
                record={record}
                field='blankPrepared'
            />
        ),
    },
]
